import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';

const Content = styled.div`
  border: 1px solid ${tokens.color.gray[200]};
  border-radius: ${tokens.borderRadius[500]};
  box-sizing: border-box;
  max-width: 410px;
  padding: ${tokens.spacing[600]};
  width: 100%;
`;

export default Content;
